'use strict';

class GotoNextPage extends BaseComponent {
	static get defaultState() {
		return {
			title: _t("gotonextpage_next_station"),
			of: _t('gotonextpage_of'),
			urlNext: "/home",
			pageNumber: 1,
			pagesTotal: 5,
			showPagination: true
		}
	}

	constructor(element, state) {
		//init BaseComponent
		super(element, state);

		//set template id
		this._view = $('#atoms_gotoNextPage_GotoNextPage').html();

		//set template props
		this._props = this.state;

		return this
	}

	init() {
		Utils.ajaxify($('a', this.$el));

		return this
	}
}

if(!_.isObjectLike(site)) var site = {components:{}};
site.components.GotoNextPage = GotoNextPage;
